


export class PublicationsOtherByAuthorView {

    constructor() {
        this.id = 'author-publications';
		
		this.box = document.getElementById(this.id);
		if (!this.box) {
			
			return false;
		}
		
		this.title = this.box.querySelector('.sc_title > strong');
		
		this.ul = this.box.querySelector('.ul');
		
		this.itemTemplate = this.ul.querySelector('.li')?.cloneNode(true);
    }

    render(state) { 

		if (!state.data) { return false;} //HACK
        if (!this.box) { return false;}
		if (!this.ul) { return false;}

		const stateData = state.data;

		if (stateData.title) { this.title.textContent = stateData.title;}

		if (stateData.models) {
			
			const dummies = this.ul.querySelectorAll('.dummy');
			dummies.forEach((el, index) => {
				
				const data = stateData.models[index];

				if (!data) {
					el.parentElement.remove();
					return;
				}
				
				el.dataset.id = data.id;
				
				const titleLink = el.querySelector('.title > a');
				titleLink.href = data.url;
				
				titleLink.textContent = data.title;
				
				el.querySelector('.date').textContent = data.date;

				el.classList.remove('dummy');
			});

			this.ul.querySelectorAll('.li').forEach((li) => {
				if (!li.textContent.trim() && li.children.length === 0) { li.remove();}
			});
			
			this.box.style.display = (this.ul.querySelector('.li')) ? '' : 'none';
			
			this.box.classList.remove('dummy');
		}
    }
}